import React, { useEffect, useState, useRef } from 'react';
import { Container, Complemento } from './styles5';

import LogoErpWorks from "~/assets/logos/Logo ErpWorks Proposta.png";
import CheckUnChecked from "~/assets/logos/check_proposta_unchecked.png";

function Pagina5({ data }) {

  return (
    <>
      <Container>
        <div className="barra-sup"></div>
        <div className="barra-sup2"></div>
        <div className="barra-sup3"></div>
        <div className="barra-sup4"></div>
        <div className="header">
          <div class="text">
            <p class="titulo">Data Emissão</p>
            <p class="titulo-data">{(new Date().toLocaleString('pt-BR', { timeZone: 'UTC' }))}</p>
          </div>
        </div>
        <div className="body">
          <div class="text">
            <p class="titulo">Proposta</p>
            <p class="sub-titulo">ESCOPO</p>
          </div>
          <div class="referente">
            <p class="titulo">REFERENTE: {data?.titulo}</p>
          </div>
          <div class="escopo">
            {data?.atividades?.map((itemAtiv) => (
              <div className="item">
                <p class="titulo">{itemAtiv?.titulo}</p>
                <pre class="descricao">{itemAtiv?.descricao}</pre>
              </div>
            ))}
          </div>
        </div>
      </Container >
    </>
  );
};

export default Pagina5;